export interface ErrorCodeLookupResult {
  code: string;
  message: string | null;
}

export const lookupErrorMessage = (
  code: string | null | undefined,
  dict: Record<string, string>
): ErrorCodeLookupResult | null => {
  if (code === null || code === undefined) return null;
  const message = dict[code];
  return {
    code,
    message: typeof message === 'string' && message !== '' ? message : null,
  };
};
